// ColumnChartComponent.tsx
import React from "react";
import { Chart } from "react-google-charts";

interface ColumnChartComponentProps {
  data: any[];
  title?: string;
}

const ColumnChartComponent: React.FC<ColumnChartComponentProps> = ({ data, title = "Inventory Status" }) => {
  const options = {
    title: title,
    chartArea: { width: "75%" },
    isStacked: false,
    hAxis: {
      title: "Channels",
      titleTextStyle: {
        fontSize: 16,
        bold: true,
      },
    },
    vAxis: {
      title: "Quantity",
      minValue: 0,
    },
    series: {
      0: { color: "#5754F7" }, // Available
      1: { color: "#36A2EB" }, // Sold
    },
    legend: { position: "top" },
    annotations: {
      textStyle: {
        fontSize: 12,
        bold: true,
        color: '#000',
      }
    }
  };

  return (
    <div className="mt-3">
      <Chart
        chartType="ColumnChart"
        width="100%"
        height="400px"
        data={data}
        options={options}
      />
    </div>
  );
};

export default ColumnChartComponent;